export default __webpack_public_path__ + "static/media/welcome.15f6b7d2.svg";